(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[853],{

/***/ 10166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newStyled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(11463);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 2 modules
var emotion_serialize_browser_esm = __webpack_require__(48137);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_c39617d8_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_c39617d8_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});




/***/ }),

/***/ 19236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.styles.js


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function getFontSize(size, element, theme) {
  if (typeof size !== "undefined") {
    return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : size;
  }
  return theme.headings.sizes[element].fontSize;
}
function getLineHeight(size, element, theme) {
  if (typeof size !== "undefined" && size in theme.headings.sizes) {
    return theme.headings.sizes[size].lineHeight;
  }
  return theme.headings.sizes[element].lineHeight;
}
var useStyles = (0,create_styles/* createStyles */.k)((theme, { element, weight, size, inline }) => ({
  root: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
    fontFamily: theme.headings.fontFamily,
    fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
    fontSize: getFontSize(size, element, theme),
    lineHeight: inline ? 1 : getLineHeight(size, element, theme),
    margin: 0
  })
}));

/* harmony default export */ var Title_styles = (useStyles);
//# sourceMappingURL=Title.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Title/Title.js





var Title_defProp = Object.defineProperty;
var Title_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Title_hasOwnProp = Object.prototype.hasOwnProperty;
var Title_propIsEnum = Object.prototype.propertyIsEnumerable;
var Title_defNormalProp = (obj, key, value) => key in obj ? Title_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Title_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Title_hasOwnProp.call(b, prop))
      Title_defNormalProp(a, prop, b[prop]);
  if (Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(b)) {
      if (Title_propIsEnum.call(b, prop))
        Title_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Title_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Title_getOwnPropSymbols)
    for (var prop of Title_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Title_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  order: 1
};
const Title = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Title", defaultProps, props), { className, order, children, unstyled, size, weight, inline } = _a, others = __objRest(_a, ["className", "order", "children", "unstyled", "size", "weight", "inline"]);
  const { classes, cx } = Title_styles({ element: `h${order}`, weight, size, inline }, { name: "Title", unstyled });
  if (![1, 2, 3, 4, 5, 6].includes(order)) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(Text/* Text */.x, Title_spreadValues({
    component: `h${order}`,
    ref,
    className: cx(classes.root, className)
  }, others), children);
});
Title.displayName = "@mantine/core/Title";


//# sourceMappingURL=Title.js.map


/***/ }),

/***/ 36942:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dang-nhap",
      function () {
        return __webpack_require__(35915);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73946);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var useCountdownTimer = function(durationInSeconds) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSetState */ .v)({
        durationLeftInSeconds: null,
        isExpired: false,
        start: false
    }), 2), ref1 = ref[0], isExpired = ref1.isExpired, start = ref1.start, durationLeftInSeconds = ref1.durationLeftInSeconds, setState = ref[1];
    var startCountdown = function() {
        reset();
        setState({
            start: true
        });
    };
    var reset = function() {
        setState({
            durationLeftInSeconds: durationInSeconds,
            isExpired: false,
            start: false
        });
    };
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        return setState({
            durationLeftInSeconds: durationInSeconds
        });
    }, [
        durationInSeconds
    ]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (!start) return;
        var intervalId = setInterval(function() {
            setState({
                durationLeftInSeconds: durationLeftInSeconds - 1
            });
        }, 1000);
        if (durationLeftInSeconds <= 0) {
            setState({
                isExpired: true
            });
            clearInterval(intervalId);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        durationLeftInSeconds,
        start
    ]);
    return {
        isExpired: isExpired,
        durationLeftInSeconds: durationLeftInSeconds,
        startCountdown: startCountdown
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCountdownTimer);


/***/ }),

/***/ 25217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OtpForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useCountdownTimer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(704);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26679);
/* harmony import */ var _setup_locale_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59963);
/* harmony import */ var _setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97744);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80061);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88393);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67841);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66137);
/* harmony import */ var _mantine_form__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);












function OtpForm(param) {
    var authOtp = param.authOtp, resend = param.resend, callback = param.callback;
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var getLabel = (0,_setup_locale_provider__WEBPACK_IMPORTED_MODULE_4__/* .useLocalContext */ .u)().getLabel;
    var ref = (0,_hooks_useCountdownTimer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(120), durationLeftInSeconds = ref.durationLeftInSeconds, startCountdown = ref.startCountdown, isExpired = ref.isExpired;
    // startCountdown();
    react__WEBPACK_IMPORTED_MODULE_6__.useEffect(function() {
        startCountdown();
    }, []);
    var form = (0,_mantine_form__WEBPACK_IMPORTED_MODULE_7__/* .useForm */ .c)({
        initialValues: {
            otp: ""
        },
        validate: {
            otp: function(value) {
                return value.length > 0 ? null : getLabel("Vui l\xf2ng nhập m\xe3 x\xe1c thực");
            }
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_authOtp;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return authOtp(form.values.otp);
                    case 3:
                        rs_authOtp = _ctx.sent;
                        if (!rs_authOtp.status) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", callback());
                    case 6:
                        return _ctx.abrupt("return", form.setErrors({
                            otp: "M\xe3 x\xe1c thực kh\xf4ng hợp lệ"
                        }));
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("Error handleSubmit OtpForm => ", _ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rs_resend;
            return _root_webs_vietthien_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isExpired) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", undefined);
                    case 2:
                        _ctx.next = 4;
                        return resend();
                    case 4:
                        rs_resend = _ctx.sent;
                        if (rs_resend.status) {
                            (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__/* .appAlert */ .t)({
                                type: "success",
                                message: rs_resend.message
                            });
                            startCountdown();
                        } else {
                            (0,_setup_mantine_provider_notifications__WEBPACK_IMPORTED_MODULE_5__/* .appAlert */ .t)({
                                type: "error",
                                message: rs_resend.message
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
            onSubmit: form.onSubmit(handleSubmit),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                    label: trans === null || trans === void 0 ? void 0 : trans.otpFrom.title,
                    withAsterisk: true,
                    placeholder: trans === null || trans === void 0 ? void 0 : trans.otpFrom.placeholder
                }, form.getInputProps("otp")), {
                    sx: {
                        width: "calc(100% - 18px)"
                    },
                    styles: {
                        input: {
                            borderRight: "none",
                            borderTopRightRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    },
                    rightSection: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Tooltip */ .u, {
                        label: trans === null || trans === void 0 ? void 0 : trans.otpFrom.resend,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                            variant: "outline",
                            color: isExpired ? "dark" : "gray",
                            radius: "md",
                            styles: {
                                root: {
                                    borderTopLeftRadius: 0,
                                    borderEndStartRadius: 0
                                },
                                input: {
                                    letterSpacing: "2px"
                                }
                            },
                            // disabled={!isExpired}
                            onClick: function() {
                                return handleResend();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                weight: "normal",
                                children: isExpired ? trans === null || trans === void 0 ? void 0 : trans.otpFrom.resend : "".concat(Math.floor(durationLeftInSeconds / 60), " : ").concat(durationLeftInSeconds % 60 < 10 ? "0".concat(durationLeftInSeconds % 60) : durationLeftInSeconds % 60)
                            })
                        })
                    })
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Group */ .Z, {
                    position: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .z, {
                        type: "submit",
                        mt: "sm",
                        fullWidth: true,
                        variant: "outline",
                        color: "dark",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                            weight: "500",
                            transform: "uppercase",
                            children: trans === null || trans === void 0 ? void 0 : trans.otpFrom.submit
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 35915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ DangNhap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/Layout/Container/Container.js
var Container = __webpack_require__(6559);
// EXTERNAL MODULE: ./hooks/useAuth.js
var useAuth = __webpack_require__(35985);
// EXTERNAL MODULE: ./hooks/useTrans.js + 2 modules
var useTrans = __webpack_require__(26679);
// EXTERNAL MODULE: ./setup/locale-provider/index.js
var locale_provider = __webpack_require__(59963);
// EXTERNAL MODULE: ./setup/mantine-provider/notifications.js
var notifications = __webpack_require__(97744);
// EXTERNAL MODULE: ./utils/localStorage.js
var localStorage = __webpack_require__(44061);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(64523);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Card/Card.js + 4 modules
var Card = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/PasswordInput/PasswordInput.js + 2 modules
var PasswordInput = __webpack_require__(73193);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(66137);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(38090);
// EXTERNAL MODULE: ./node_modules/@mantine/form/esm/use-form.js + 15 modules
var use_form = __webpack_require__(98903);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./pages/dang-ky/components/OtpForm.js
var OtpForm = __webpack_require__(25217);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./setup/flexbiz-api-provider/index.js + 4 modules
var flexbiz_api_provider = __webpack_require__(34733);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiFillFacebook.js
var AiFillFacebook = __webpack_require__(92613);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
;// CONCATENATED MODULE: ./pages/dang-nhap/components/FbLogin.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 300px;\n  height: 38px;\n  padding: 12px;\n  border: none;\n  border-radius: 20px;\n  opacity: 0.85;\n  font-size: 17px;\n  line-height: 20px;\n  text-decoration: none;\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n\n  background-color: #3b5998;\n  color: white;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  span {\n    width: 100%;\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Btn = emotion_styled_browser_esm/* default.button */.Z.button(_templateObject());
function FbLogin() {
    var trans = (0,useTrans/* default */.Z)();
    var context = (0,flexbiz_api_provider/* useApiContext */.Q)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), status = ref[0], setStatus = ref[1];
    // const [facebookAuth, setFacebookAuth] = React.useState(null);
    // const [facebookProfile, setFacebookProfile] = React.useState(null);
    var goBack = function() {
        router.back();
        return null;
    };
    var permissionOptions = {
        scope: "public_profile,email",
        return_scopes: true
    };
    react.useEffect(function() {
        // const script = document.createElement("script");
        // script.src =
        //   "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v14.0&appId=654079745649186&autoLogAppEvents=1";
        // script.async = true;
        // script.nonce = "1341tSaz";
        // script.crossOrigin = "anonymous";
        // document.querySelector("body")?.appendChild(script);
        window.fbAsyncInit = function() {
            FB.init({
                appId: "312745678219328",
                cookie: true,
                xfbml: true,
                version: "v14.0"
            });
            FB.AppEvents.logPageView();
            setStatus(true);
        };
        (function(d, s, id) {
            var js;
            var fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/vi_VN/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    }, []);
    var createUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, urlToCreateProfile, createdProfile, creatdUserProfile, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                        urlToCreateProfile = "".concat("https://api.flexzen.app", "/createUser/facebook?id_app=").concat("615fa1791fc31763c7253668", "&access_token=").concat(data.accessToken, "&group_id=").concat("643f69bb564a7f03c18642bb");
                        if (data.email) urlToCreateProfile += "&email=".concat(data.email);
                        if (data.password) urlToCreateProfile += "&password=".concat(data.password);
                        if (data.name) urlToCreateProfile += "&name=".concat(data.name);
                        _ctx.next = 7;
                        return context.apis.asyncGet(urlToCreateProfile);
                    case 7:
                        createdProfile = _ctx.sent;
                        _ctx.next = 10;
                        return context.apis.asyncGetUserInfoByToken(data.accessToken);
                    case 10:
                        creatdUserProfile = _ctx.sent;
                        // // console.log("🚀 ~ createUser ~ creatdUserProfile", creatdUserProfile);
                        if (creatdUserProfile) {
                            creatdUserProfile.token = data.accessToken;
                            (0,localStorage/* setToStorage */.Pp)("updateInfo", true);
                            (0,localStorage/* setToStorage */.Pp)("token", data.accessToken);
                            goBack();
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFacebookResponse = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authResponse) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return createUser({
                            accessToken: authResponse.accessToken,
                            name: authResponse.displayName
                        });
                    case 3:
                        _ctx.next = 9;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("error", _ctx.t0);
                        console.error({
                            message: "Lỗi handleFacebookResponse"
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function handleFacebookResponse(authResponse) {
            return _ref.apply(this, arguments);
        };
    }();
    function initFacebookLogin() {
        return _initFacebookLogin.apply(this, arguments);
    }
    function _initFacebookLogin() {
        _initFacebookLogin = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        FB.init({
                            appId: "312745678219328",
                            cookie: true,
                            xfbml: true,
                            version: "v14.0"
                        });
                        FB.getLoginStatus(function(res) {
                            if (res.authResponse) {
                                // console.log("res.authResponse", res.authResponse);
                                // setFacebookAuth(res.authResponse);
                                handleFacebookResponse(res.authResponse);
                                return;
                            }
                            FB.login(function(res) {
                                if (res.authResponse) {
                                    // console.log("res.authResponse", res.authResponse);
                                    // setFacebookAuth(res.authResponse);
                                    handleFacebookResponse(res.authResponse);
                                }
                            }, permissionOptions);
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _initFacebookLogin.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Btn, {
            className: "fb btn",
            onClick: initFacebookLogin,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AiFillFacebook/* AiFillFacebook */.s, {
                    color: "#fff",
                    size: 30
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: trans === null || trans === void 0 ? void 0 : trans.login.loginFB
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/dang-nhap/components/ForgetPassForm.js
/* eslint-disable camelcase */ 












var ReCAPTCHA = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6140).then(__webpack_require__.bind(__webpack_require__, 6140));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6140)
            ];
        }
    }
});
function ForgetPassForm(param) {
    var sendOtp = param.sendOtp, authOtp = param.authOtp, resend = param.resend, resetPassword = param.resetPassword, callback = param.callback;
    var trans = (0,useTrans/* default */.Z)();
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), step = ref[0], setStep = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isReCaptchaNeeded = ref1[0], setIsReCaptchaNeeded = ref1[1];
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            email: ""
        },
        validate: {
            email: function(value) {
                return value.length > 0 ? null : trans === null || trans === void 0 ? void 0 : trans.forgotPassword.validate.blank;
            }
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var rs_sendOtp, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return sendOtp(form.values.email);
                    case 3:
                        rs_sendOtp = _ctx.sent;
                        if (rs_sendOtp.status) {
                            setStep(2);
                        } else {
                            form.setErrors({
                                email: trans === null || trans === void 0 ? void 0 : trans.forgotPassword.validate.send
                            });
                        }
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error ForgetPassForm handleSubmit => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        form.setErrors({
                            email: ((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderByStep = function() {
        switch(step){
            case 1:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: form.onSubmit(handleSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            withAsterisk: true,
                            label: trans === null || trans === void 0 ? void 0 : trans.forgotPassword.username
                        }, form.getInputProps("email")), {
                            placeholder: trans === null || trans === void 0 ? void 0 : trans.forgotPassword.placeholder.username,
                            mb: 5,
                            onFocus: function() {
                                setIsReCaptchaNeeded(true);
                            }
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                            position: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                type: "submit",
                                mt: "sm",
                                fullWidth: true,
                                variant: "outline",
                                color: "dark",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    weight: "500",
                                    transform: "uppercase",
                                    children: trans === null || trans === void 0 ? void 0 : trans.forgotPassword.submit
                                })
                            })
                        })
                    ]
                });
            case 2:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpForm/* default */.Z, {
                    resend: resend,
                    authOtp: authOtp,
                    callback: function() {
                        setStep(3);
                    }
                });
            case 3:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassForm, {
                    resetPassword: resetPassword,
                    callback: callback
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isReCaptchaNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCAPTCHA, {}),
            renderByStep()
        ]
    });
};
function ResetPassForm(param) {
    var resetPassword = param.resetPassword, callback = param.callback;
    var trans = (0,useTrans/* default */.Z)();
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            newPassword: "",
            reNewPassword: ""
        },
        validate: {
            newPassword: function(value) {
                return value.length > 0 ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*#?&]{6,}$/.test(value) ? null : getLabel("Mật khẩu c\xf3 \xedt nhất 6 k\xfd tự v\xe0 \xedt nhất 1 chữ hoa, 1 chữ thường, 1 chữ số") : getLabel("Mật khẩu kh\xf4ng được để trống");
            },
            reNewPassword: function(value, values) {
                return value.length > 0 ? value !== values.newPassword ? getLabel("Nhập lại mật khẩu kh\xf4ng tr\xf9ng khớp") : null : getLabel("Mật khẩu kh\xf4ng được để trống");
            }
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var rs_resetPassword, ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return resetPassword(form.values);
                    case 3:
                        rs_resetPassword = _ctx.sent;
                        if (rs_resetPassword.status) {
                            callback(rs_resetPassword);
                        } else {
                            form.setErrors({
                                newPassword: rs_resetPassword.message
                            });
                        }
                        _ctx.next = 12;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        console.log("Error ResetPassForm handleSubmit => ", ((ref = _ctx.t0.data) === null || ref === void 0 ? void 0 : ref.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        form.setErrors({
                            newPassword: ((ref1 = _ctx.t0.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: form.onSubmit(handleSubmit),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    withAsterisk: true,
                    label: trans === null || trans === void 0 ? void 0 : trans.resetPassword.newPassword
                }, form.getInputProps("newPassword")), {
                    placeholder: trans === null || trans === void 0 ? void 0 : trans.resetPassword.placeholder,
                    mb: 5
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    withAsterisk: true,
                    label: trans === null || trans === void 0 ? void 0 : trans.resetPassword.reNewPassword
                }, form.getInputProps("reNewPassword")), {
                    placeholder: trans === null || trans === void 0 ? void 0 : trans.resetPassword.placeholder,
                    mb: 5
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    position: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        mt: "sm",
                        fullWidth: true,
                        variant: "outline",
                        color: "dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            weight: "500",
                            transform: "uppercase",
                            children: trans === null || trans === void 0 ? void 0 : trans.resetPassword.submit
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/dang-nhap/components/GgLogin.js








function GgLogin() {
    var context = (0,flexbiz_api_provider/* useApiContext */.Q)();
    var divRef = react.useRef(null);
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), gsiScriptLoaded = ref[0], setGsiScriptLoaded = ref[1];
    var goBack = function() {
        router.back();
        return null;
    };
    var responseGoogle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            var urlProfile, profile;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        urlProfile = "".concat("https://api.flexzen.app", "/createUser/google?id_app=").concat("615fa1791fc31763c7253668", "&group_id=").concat("643f69bb564a7f03c18642bb", "&id_token=").concat(response);
                        _ctx.prev = 1;
                        _ctx.t0 = JSON;
                        _ctx.next = 5;
                        return context.apis.asyncGet(urlProfile);
                    case 5:
                        _ctx.t1 = _ctx.sent;
                        profile = _ctx.t0.parse.call(_ctx.t0, _ctx.t1);
                        if (profile && profile.access_token) {
                            (0,localStorage/* setToStorage */.Pp)("updateInfo", true);
                            (0,localStorage/* setToStorage */.Pp)("token", profile.access_token);
                            // localStorage.setItem("updateInfo", true);
                            // localStorage.setItem("token", profile.access_token);
                            goBack();
                        }
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t2 = _ctx["catch"](1);
                        console.log("error", _ctx.t2);
                        console.error({
                            message: "Lỗi responseGoogle"
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function responseGoogle(response) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        var ref;
        var initializeGsi = function() {
            // Typescript will complain about window.google
            // Add types to your `react-app-env.d.ts` or //@ts-ignore it.
            if (!window.google || gsiScriptLoaded) return;
            setGsiScriptLoaded(true);
            window.google.accounts.id.initialize({
                client_id: "480642379696-vdulenqr3l49jtvec2bbgj1m228bper6.apps.googleusercontent.com",
                callback: handleCredentialResponse
            });
            window.google.accounts.id.renderButton(divRef.current, {
                theme: "outline",
                size: "large",
                shape: "circle",
                text: "signin_with",
                width: 300,
                logo_alignment: "left"
            } // customization attributes
            );
        };
        var script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.onload = initializeGsi;
        script.async = true;
        script.id = "google-client-script";
        (ref = document.querySelector("body")) === null || ref === void 0 ? void 0 : ref.appendChild(script);
        return function() {
            var // Cleanup function that runs when component unmounts
            ref, ref1;
            (ref = window.google) === null || ref === void 0 ? void 0 : ref.accounts.id.cancel();
            (ref1 = document.getElementById("google-client-script")) === null || ref1 === void 0 ? void 0 : ref1.remove();
        };
    }, [
        handleCredentialResponse
    ]);
    function handleCredentialResponse(response) {
        return _handleCredentialResponse.apply(this, arguments);
    }
    function _handleCredentialResponse() {
        _handleCredentialResponse = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(response) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // console.log("response", response);
                        // const responsePayload = jwt_decode(response.credential);
                        responseGoogle(response.credential);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleCredentialResponse.apply(this, arguments);
    }
    return  true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: divRef
    });
};

;// CONCATENATED MODULE: ./pages/dang-nhap/index.page.js
/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable camelcase */ /* eslint-disable jsx-a11y/anchor-is-valid */ 























var index_page_ReCAPTCHA = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6140).then(__webpack_require__.bind(__webpack_require__, 6140));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6140)
            ];
        }
    }
});
function DangNhap() {
    var trans = (0,useTrans/* default */.Z)();
    var getLabel = (0,locale_provider/* useLocalContext */.u)().getLabel;
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* default */.Z)(), login = ref.login, sendOtp = ref.sendOtp, authOtp = ref.authOtp, resend = ref.resend, resetPassword = ref.resetPassword;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), opened = ref1[0], setOpened = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), forgetPass = ref2[0], setForgetPass = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), modalTitle = ref3[0], setModalTitle = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isReCaptchaNeeded = ref4[0], setIsReCaptchaNeeded = ref4[1];
    react.useEffect(function() {
        var hasToken = Boolean((0,localStorage/* getFromStorage */.L2)("token"));
        if (hasToken) {
            router.push("/");
        }
    }, []);
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            email: "",
            password: ""
        },
        validate: {
            email: function(value) {
                return value.length > 0 ? null : trans === null || trans === void 0 ? void 0 : trans.login.validate.blank;
            },
            password: function(value) {
                return value.length > 0 ? null : trans === null || trans === void 0 ? void 0 : trans.login.validate.blankPassword;
            }
        }
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var rs_login, rs_otpInfo;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return login(form.values.email, form.values.password);
                    case 3:
                        rs_login = _ctx.sent;
                        if (!rs_login.status) {
                            _ctx.next = 8;
                            break;
                        }
                        {
                            router.back();
                        }
                        _ctx.next = 16;
                        break;
                    case 8:
                        if (!rs_login.require_verify) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.next = 11;
                        return sendOtp(form.values.email);
                    case 11:
                        rs_otpInfo = _ctx.sent;
                        if (rs_otpInfo.status) {
                            setModalTitle(rs_login.message);
                            setOpened(true);
                        } else {
                            form.setErrors({
                                email: rs_otpInfo.message
                            });
                        // console.log("a", form.values.email);
                        }
                        _ctx.next = 16;
                        break;
                    case 15:
                        {
                            form.setErrors({
                                email: rs_login.message
                            });
                        }
                    case 16:
                        _ctx.next = 22;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("Error handleSubmit => ", _ctx.t0.data.message || _ctx.t0.message || _ctx.t0.error || _ctx.t0);
                        form.setErrors({
                            email: _ctx.t0.data.message || _ctx.t0.message || _ctx.t0.error || _ctx.t0
                        });
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    // const resend = async () => {
    //   try {
    //     let rs_otpInfo = await sendOtp(form.values.email);
    //     if (rs_otpInfo.status) {
    //       return {
    //         status: true,
    //         message: `Mã xác thực đã gửi đến ${form.values.email}`,
    //       };
    //     } else {
    //       return {
    //         status: false,
    //         message: `Gửi lại mã xác thực không thành công`,
    //       };
    //     }
    //   } catch (error) {
    //     console.log(
    //       "Error handleSubmit => ",
    //       error.message || error.error || error
    //     );
    //     return {
    //       status: false,
    //       message: `Gửi lại mã xác thực không thành công`,
    //     };
    //   }
    // };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        component: "div",
        py: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: trans === null || trans === void 0 ? void 0 : trans.login.seoTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "sm",
                sx: {
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
                        shadow: "sm",
                        p: "lg",
                        radius: "md",
                        withBorder: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                    order: 3,
                                    children: trans === null || trans === void 0 ? void 0 : trans.login.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: form.onSubmit(handleSubmit),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.login.username,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("email")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.login.placeholder.username,
                                        onFocus: function() {
                                            setIsReCaptchaNeeded(true);
                                        },
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordInput/* PasswordInput */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        withAsterisk: true,
                                        label: trans === null || trans === void 0 ? void 0 : trans.login.password,
                                        labelProps: {
                                            style: {
                                                color: "#000"
                                            }
                                        }
                                    }, form.getInputProps("password")), {
                                        placeholder: trans === null || trans === void 0 ? void 0 : trans.login.placeholder.password,
                                        mb: 5
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                        position: "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                size: "sm",
                                                color: "blue",
                                                onClick: function() {
                                                    return setForgetPass(true);
                                                },
                                                children: trans === null || trans === void 0 ? void 0 : trans.login.forgotPass
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                        position: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            type: "submit",
                                            mt: "sm",
                                            fullWidth: true,
                                            variant: "outline",
                                            color: "dark",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                weight: "500",
                                                transform: "uppercase",
                                                children: trans === null || trans === void 0 ? void 0 : trans.login.submit
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                    sx: function(theme) {
                                        return (0,_define_property/* default */.Z)({
                                            display: "flex"
                                        }, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
                                            flexDirection: "column",
                                            justifyContent: "center"
                                        });
                                    },
                                    mt: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                            size: "sm",
                                            mr: 4,
                                            children: trans === null || trans === void 0 ? void 0 : trans.login.swap
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            scroll: false,
                                            href: "/dang-ky",
                                            replace: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                                    weight: "700",
                                                    transform: "uppercase",
                                                    size: "sm",
                                                    align: "center",
                                                    children: trans === null || trans === void 0 ? void 0 : trans.login.signup
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
                                my: 10,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    size: "sm",
                                    transform: "uppercase",
                                    children: trans === null || trans === void 0 ? void 0 : trans.login.or
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                                sx: function(theme) {
                                    return (0,_define_property/* default */.Z)({
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flexDirection: "row"
                                    }, "".concat(theme.fn.smallerThan("sm")), {
                                        flexDirection: "column",
                                        height: 90
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FbLogin, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GgLogin, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                position: "center",
                                align: "center",
                                grow: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                        opened: opened,
                        onClose: function() {
                            return setOpened(false);
                        },
                        title: getLabel(modalTitle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpForm/* default */.Z, {
                            authOtp: authOtp,
                            resend: resend,
                            callback: function(rs) {
                                (0,localStorage/* setToStorage */.Pp)("token", rs.token);
                                (0,localStorage/* setToStorage */.Pp)("updateInfo", true);
                                router.back();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                        opened: forgetPass,
                        onClose: function() {
                            return setForgetPass(false);
                        },
                        title: trans === null || trans === void 0 ? void 0 : trans.forgotPassword.title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgetPassForm, {
                            sendOtp: sendOtp,
                            authOtp: authOtp,
                            resend: resend,
                            resetPassword: resetPassword,
                            callback: function(rs) {
                                (0,notifications/* appAlert */.t)({
                                    type: "success",
                                    message: rs.message
                                });
                                setForgetPass(false);
                            }
                        })
                    })
                ]
            }),
            isReCaptchaNeeded && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_page_ReCAPTCHA, {})
        ]
    });
};


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* unused reexport */ __webpack_require__(20699)


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8795,9774,2888,179], function() { return __webpack_exec__(36942); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);